import React from 'react';
import PropTypes from "prop-types";
import GenericLabel from '../GenericLabel';
import Icon from '../Icon';

export default class CardParentBox extends React.Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    label: PropTypes.string,
    toggleChildren: PropTypes.func,
    icon: PropTypes.string,
    fontFamily: PropTypes.string,
    iconSize: PropTypes.string,
    chevron: PropTypes.bool,
    showChildren: PropTypes.bool,
    className: PropTypes.string
  };

  static defaultProps = {
    type: 'wide',
    fontFamily: 'zmdi',
    iconSize: 'medium',
    chevron: true,
    showChildren: false
  }

  render() {
    const { label, icon, fontFamily, iconSize, chevron, additionalClasses, toggleChildren, showChildren, className } = this.props;
    const iconOpenClass = showChildren ? ' zmdi-hc-rotate-90' : '';
    return (
      <div className={className}>
        <button className={`card-parent-label`} onClick={toggleChildren} role="button">
          {icon && <Icon iconType={icon} fontFamily={fontFamily} additionalClasses={additionalClasses} size={iconSize}/>}
          <GenericLabel label={label} icon={chevron && `chevron-right`} additionalClasses={`${iconOpenClass}`} iconPosition="right" />
        </button>
      </div>
    )
  }
}
